export default __webpack_public_path__ + "static/media/UploadIcon.9725c96d.svg";